/**
 * Update tags let Lexical listeners tell externally-driven state changes apart
 * from user edits. The controlled value flow uses one so downstream editor
 * subscriptions can skip their own re-entrant updates and avoid feedback loops.
 */
export const EXTERNAL_VALUE_UPDATE_TAG = 'external-value';
//# sourceMappingURL=updateTags.js.map